// extracted by mini-css-extract-plugin
export var contrastLow = "_22-1";
export var externalLink = "_22-2";
export var externalLinkIcon = "_22-3";
export var link = "_22-0";
export var linkLabel = "_22-4";